import { InverseHeader } from '@jouzen/ecom-components';

import PopTechSpecs from '@/app/[locale]/product/rings/_components/shared/PopTechSpecs';
import PopWhatsIncluded from '@/app/[locale]/product/rings/_components/shared/PopWhatsIncluded';

import { popTechSpecsFeatures } from './data/popTechSpecsFeatures';
import { popWhatsIncludedItems } from './data/popWhatsIncludedItems';

export function PopBottom(): JSX.Element {
  return (
    <InverseHeader enter>
      <div className="bg-gray-600 pt-16 text-sandstone-200 lg:pt-20">
        <PopTechSpecs features={popTechSpecsFeatures} />
        <PopWhatsIncluded items={popWhatsIncludedItems} />
      </div>
    </InverseHeader>
  );
}
